<template>
  <b-form class="px-2 mb-3">
    <b-row>
      <b-col lg="3">
        <b-form-group label="Add-Ons" label-class="product-creation-section-labels py-0">
          <small class="sub-section-labels">Create customizable add-ons</small>
        </b-form-group>
      </b-col>
      <b-col lg="5">
        <b-form-group>
          <ProductAddOnsSingle />
        </b-form-group>
        <b-form-group>
          <b-button
            variant="ghost"
            class="text-primary border font-weight-bold create-button px-3"
            @click="create">
            + Create Add-On
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>
    <ProductAddOnModal
      :is_manage="is_manage"
      :add_on_category_index="add_on_category_index" />
  </b-form>
</template>

<script>
import ProductAddOnsSingle from "./ProductAddOnsSingle";
import ProductAddOnModal from "./ProductAddOnModal";

export default {
  components: { ProductAddOnsSingle, ProductAddOnModal },
  data() {
    return {
      is_manage: false,
      add_on_category_index: null
    }
  },
  methods: {
    create() {
      this.$root.$emit("bv::show::modal", "product-addons-modal");
    }
  }
}
</script>
